import React, { useRef, useEffect, useState } from "react";
import "shaka-player/dist/controls.css";
import "./player.css";
const shaka = require("shaka-player/dist/shaka-player.ui.js");

const ShakaDrmPlayer = () => {
  const [drmType, setDrmType] = useState(null);
  const [manifestUrl, setManifestUrl] = useState(
    "https://kalingoott.s3.us-east-1.amazonaws.com/transcoded/1740067157754/wwpr.mpd"
  );
  const [licenseUrl, setLicenseUrl] = useState(
    "https://widevine-dash.ezdrm.com/proxy?pX=03553F"
  );
  const [certificateUrl, setCertificateUrl] = useState("");
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  useEffect(() => {
    detectDRM();
  }, []);

  const detectDRM = () => {
    const ua = navigator.userAgent;
    if (ua.includes("Edge") || ua.includes("Trident")) {
      setDrmType("playready");
    } else if (ua.includes("Chrome") || ua.includes("Android")) {
      setDrmType("widevine");
    } else if (ua.includes("Safari") && !ua.includes("Chrome")) {
      setDrmType("fairplay");
    }
  };

  const loadVideo = () => {
    if (
      !manifestUrl ||
      !licenseUrl ||
      (drmType === "fairplay" && !certificateUrl)
    ) {
      alert("Please provide all required URLs");
      return;
    }

    if (!shaka.Player.isBrowserSupported()) {
      alert("Shaka Player is not supported on this browser.");
      return;
    }
    setIsVideoLoaded(true);
  };

  return (
    <div>
      <h3>DRM Video Player ({drmType?.toUpperCase() || "Detecting..."})</h3>
      <input
        type="text"
        placeholder="Manifest URL"
        value={manifestUrl}
        onChange={(e) => setManifestUrl(e.target.value)}
      />
      <input
        type="text"
        placeholder="License Server URL"
        value={licenseUrl}
        onChange={(e) => setLicenseUrl(e.target.value)}
      />
      {drmType === "fairplay" && (
        <input
          type="text"
          placeholder="Certificate URL"
          value={certificateUrl}
          onChange={(e) => setCertificateUrl(e.target.value)}
        />
      )}
      <button onClick={loadVideo}>Load Video</button>
      {isVideoLoaded && (
        <VideComponent
          manifestUrl={manifestUrl}
          drmType={drmType}
          licenceUrl={licenseUrl}
          certUrl={certificateUrl}
        />
      )}
    </div>
  );
};

export default ShakaDrmPlayer;

const getDrmTypeServerMap = (licenceServerUrl, certificateUrl) => {
  return {
    playready: {
      servers: {
        "com.microsoft.playready": licenceServerUrl,
      },
      advanced: {
        "com.microsoft.playready": {
          videoRobustness: "SW_SECURE_CRYPTO",
          audioRobustness: "SW_SECURE_CRYPTO",
        },
      },
    },
    widevine: {
      servers: {
        "com.widevine.alpha": licenceServerUrl,
      },
      advanced: {
        "com.widevine.alpha": {
          videoRobustness: "SW_SECURE_CRYPTO",
          audioRobustness: "SW_SECURE_CRYPTO",
        },
      },
    },
    fairplay: {
      servers: {
        "com.apple.fps.1_0": licenceServerUrl,
      },
      advanced: {
        "com.apple.fps.1_0": {
          serverCertificateUri: certificateUrl,
          videoRobustness: "SW_SECURE_CRYPTO",
          audioRobustness: "SW_SECURE_CRYPTO",
        },
      },
    },
  };
};

const VideComponent = ({ manifestUrl, drmType, licenceUrl, certUrl }) => {
  const videoComponent = useRef(null);
  const videoContainer = useRef(null);

  // Error handler function
  const onError = (error) => {
    console.error("Error code", error.code, "object", error);
  };

  useEffect(() => {
    const video = videoComponent.current;
    const videoContainerEl = videoContainer.current;

    // Initialize Shaka Player
    const player = new shaka.Player(video);

    // Setting up DRM configuration
    player.configure({
      drm: {
        ...getDrmTypeServerMap(licenceUrl, certUrl)[drmType],
      },
    });

    // Setting up Shaka Player UI
    const ui = new shaka.ui.Overlay(player, videoContainerEl, video);
    ui.getControls();

    // Listen for error events
    player.addEventListener("error", (event) => onError(event.detail));

    // Try to load a manifest (asynchronous process)
    player
      .load(manifestUrl)
      .then(() => console.log("The video has now been loaded!"))
      .catch(onError);
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  return (
    <div className="video-container" ref={videoContainer}>
      <video
        className="shaka-video"
        ref={videoComponent}
        poster="//shaka-player-demo.appspot.com/assets/poster.jpg"
      />
    </div>
  );
};
